import {
  FacetSearch as HeadlessFacetSearch,
  FacetSearchState,
  SpecificFacetSearchResult,
} from '@coveo/headless';
import { FunctionComponent } from 'react';
import React from 'react';

export interface FacetSearchProps {
  controller: HeadlessFacetSearch;
  facetState: FacetSearchState;
  isValueSelected: (facetSearchValue: SpecificFacetSearchResult) => boolean;
}

export const FacetSearch: FunctionComponent<FacetSearchProps> = (props) => {
  const onInput = (text: string) => {
    props.controller.updateText(text);
    props.controller.search();
  };

  return (
    <div className="coveo-advanced-query__facet-search">
      <input
        type="text"
        onInput={(e) => onInput(e.currentTarget.value)}
        placeholder="Search more..."
      />
      { props?.facetState?.query && props?.facetState?.values?.length > 0 && (
        <ol className="coveo-advanced-query__facet-filters">
          { props.facetState.values.map( ( facetSearchValue ) => (
            <li
              key={ facetSearchValue?.displayValue }
              className="coveo-advanced-query__facet-filter"
            >
              <label className="coveo-advanced-query__facet-filter-label coveo-advanced-query__checkbox">
                <input
                  type="checkbox"
                  className="coveo-advanced-query__checkbox-input"
                  value={ facetSearchValue?.displayValue }
                  onChange={ (e) => {
                    if ( e.target.checked ) {
                      props.controller.select( facetSearchValue );
                    }
                  }}
                />
                <span className="coveo-advanced-query__checkbox-text">{ facetSearchValue.displayValue } ({ facetSearchValue.count })</span>
              </label>
            </li>
          ) ) }
        </ol>
      ) }
    </div>
  );
};
